import { createContext } from 'react';
import { post } from '../../common/Api';

export const PERSISTENCE_KEY = 'geisc';

export const AuthContext = createContext();

export const ActionTypes = Object.freeze({
    LOGIN: 0,
    LOGOUT: 1,
    REGISTER: 2
});

export const initialState = {
    authority: undefined,
    user: {
        accessToken: undefined,
        email: undefined,
        loggedIn: false,
        refreshToken: undefined,
        registered: false,
        details: undefined,
        tid: undefined,
        tokenExpires: undefined,
        tokenCreated: undefined
    }
};

export const AuthReducer = (state, action) => {
    const { type, data } = action;

    if (ActionTypes.LOGIN === type) {
        return {
            ...state,
            user: {
                ...data
            }
        };
    } else if (ActionTypes.LOGOUT === type) {
        return {
            ...state,
            user: initialState.user
        };
    } else if (ActionTypes.REGISTER === type) {
        return {
            ...state,
            user: {
                ...data
            }
        };
    }
};

export const logout = async (revocationUrl, cliendId, clientSecret, accessToken, refreshToken) => {
    if (revocationUrl && cliendId && clientSecret && accessToken && refreshToken) {
        const refreshTokenRevocationBody = {
            client_id: cliendId,
            client_secret: clientSecret,
            token: refreshToken,
            token_type_hint: 'refresh_token'
        };

        const refreshTokenRevocationResponse = await post(revocationUrl, new URLSearchParams(refreshTokenRevocationBody), undefined, 'application/x-www-form-urlencoded', {
            Authorization: `Bearer ${accessToken}`
        });

        if (refreshTokenRevocationResponse !== null && refreshTokenRevocationResponse?.isEmpty()) {
            return true;
        }
    }

    return false;
};

export const refreshToken = async (endpoint, refreshToken, clientId, clientSecret) => {   
    const tokenRequestBody = {
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: 'refresh_token',
        refresh_token: refreshToken
    };
    
    return await post(endpoint, new URLSearchParams(tokenRequestBody), undefined, 'application/x-www-form-urlencoded');
};
